<template>
<div class="wrapper list_wrapper">
    <div class="wrapper list_top_wrapper">
        <div class="container list_top_container">
            <div class="list_controller_container list_top_controller_container" v-show="list_controllers['top_controller'].length">
                <a v-for="list_controller in list_controllers['top_controller']" v-show="show_controller(list_controller.name)" :class="list_controller.icon_class" :title="list_controller.label" @click="list_controller.action()" :href="list_controller.href()" :download="list_controller.download()" :target="list_controller.target"></a>
            </div>
            <div class="list_top_filter_container" v-show="show_controller('filter')">
                <template v-for="field in fields">
                <div v-if="field.field_available_options && ($root.panel === 'admin' || field.field_available_options.length > 1)" class="list_filter">
                    <div class="select_container" :title="formatted_filter_value(field.name)">
                        <!--                    <select v-model="list_filters[field.name]" @change="filter_change(field.name)">-->
                        <!--                        <option value="_all">&#45;&#45; Filter by {{ field.display_name }} &#45;&#45;</option>-->
                        <select @change="set_filter(field.name,'select', $event)">
                            <option value="" v-show="!list_filters[field.name].length">-- Filter by {{ field.display_name }} --</option>
                            <option value="_all" v-show="list_filters[field.name].length">-- Show all --</option>
                            <option :value="field_available_option.id" v-for="field_available_option in field.field_available_options">{{ field_available_option.name }}</option>
                        </select>
                        <div class="select_overlay_display" v-show="list_filters[field.name].length" v-html="formatted_filter_value(field.name)"></div>
                    </div>
                </div>
                <div v-else-if="field.field_type === 'datetime-local'" class="list_filter">
                    <div class="select_container" :title="formatted_filter_value(field.name)">
                        <select v-model="show_date_filter[field.name]" @change="date_filter_change(field.name,$event)">
                            <option value="" v-show="!list_filters[field.name].length">-- Filter by {{ field.display_name }} --</option>
                            <option value="_all" v-show="list_filters[field.name].length">-- Show all --</option>
<!--                            <option @click="show_date_filter[field.name] = 'start_date'">&#45;&#45; Set start date &#45;&#45;</option>-->
<!--                            <option @click="show_date_filter[field.name] = 'end_date'">&#45;&#45; Set end date &#45;&#45;</option>-->
                            <option value="start_date">-- Set start date --</option>
                            <option value="end_date">-- Set end date --</option>
                            <option value="last_month">-- Last Month --</option>
                            <option value="current_month">-- Current Month --</option>
                        </select>
                        <div class="select_overlay_display" v-show="list_filters[field.name].length" v-html="formatted_filter_value(field.name)"></div>
                        <div class="sub_input_overlay" v-show="show_date_filter[field.name]">
                            <input type="date" @change="set_filter(field.name,show_date_filter[field.name], $event)" :min="date_filter_attribute(field.name,'min')" :max="date_filter_attribute(field.name,'max')">
                        </div>
                    </div>
<!--                    <input type="date" class="filter_date_start" @change="set_filter(field.name,'start_date', $event)">-->
<!--                    <span> to </span>-->
<!--                    <input type="date" class="filter_date_end" @change="set_filter(field.name,'end_date', $event)">-->
                </div>
                </template>
                <div class="list_filter">
<!--                    <label v-show="filter_by_keywords !== ''">Filter by Title:</label>-->
                    <input type="text" class="list_filter_by_keywords" v-model="filter_by_keywords" placeholder="Filter by Title">
                </div>
            </div>
            <div class="list_top_orderby_container">
                <label>Order By</label>
                <div class="select_container">
<!--                    <select v-model="order_by">-->
                    <select :value="order_by" @change="set_list_order($event.target.value,null)">
                        <option v-for="field in fields" :value="field.name">{{ field.display_name }}</option>
                    </select>
                </div>
                <div class="select_container">
<!--                    <select v-model="order_seq">-->
                    <select :value="order_seq" @change="set_list_order(null, $event.target.value)">
                        <option value="desc">Descending</option>
                        <option value="asc">Ascending</option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <display-message :option="message_option"></display-message>
    <div class="container list_container" :class="'list_container_order_'+order_seq">
        <div class="list_row list_title_row">
            <div class="list_column" v-for="field in fields" :class="'list_column_'+field.name+(order_by===field.name?' list_column_order_by':'')" @click="set_list_order(field)">{{ field.display_name }}</div>
<!--            <div class="list_column" v-if="$root.panel === 'client' && ['trust','super','register_company','loan_agreement'].indexOf(list_name) !== -1">Download</div>-->
            <div class="list_column list_column_company_admin" v-if="$root.panel === 'client' && list_name == 'user' && current_user._ref_company" style="text-align: center;">Admin</div>
            <div class="list_column list_column_company_admin" v-if="$root.panel === 'admin' && list_name == 'user'" style="text-align: center;" title="Company Admin">CAdmin</div>
            <div class="list_column list_column_controller_container" v-if="list_controllers['row_controller'].length">&nbsp;</div>
<!-- Todo: Check whether controller exist in current list -->
        </div>
        <div class="list_row" v-for="row in filtered_list">
            <div class="list_column" v-for="field in fields" :class="'list_column_'+field.name" :title="formatted_content(row,field)"><span v-html="formatted_content(row,field)"></span><!--{{ row[field.name] }}--></div>

            <!--<div class="list_column" v-if="$root.panel === 'client' && ['trust','super','register_company','loan_agreement'].indexOf(list_name) !== -1">
                <select v-if="row._ref_list_document && row._ref_list_document.length > 1" v-model="row._current_chosen_document_index">
                    <option v-for="(document,document_index) in row._ref_list_document" :value="document_index" v-html="document.display_name+'.'+document.extension"></option>
                </select>
                <p v-else-if="row._ref_list_document && row._ref_list_document.length == 1" v-html="document.display_name+'.'+document.extension"></p>
                <p v-else>N/A</p>
            </div>-->
<!--            <div class="list_column show_id">{{ show.id }}</div>-->
<!--            <div class="list_column show_display_name">{{ show.display_name }}</div>-->
<!--            <div class="list_column show_created_at">{{ $dateFormat(new Date(show.created_at) , 'DD MMM, YYYY') }}</div>-->
            <div class="list_column list_column_company_admin" v-if="$root.panel === 'client' && list_name == 'user' && current_user._ref_company" style="text-align: center;">
                <!--  My Details Page - User -->
                <!--                <a v-if="list_name == 'user'" class="glyphicon glyphicon-pencil" title="Edit" @click="$root.set_page(null,{user_id:row.id},{update_state:'replaceState',scroll_top:false})"></a>-->
                <a v-show="(!current_user.company_admin || row.id === current_user.id) && !row.company_admin" class="list_controller glyphicon glyphicon-unchecked" title="User is Normal User" style="cursor: not-allowed;opacity: 0.3;"></a>
                <a v-show="(!current_user.company_admin || row.id === current_user.id)  && row.company_admin" class="list_controller glyphicon glyphicon-check" title="User is Company Admin" style="cursor: not-allowed;opacity: 0.3;"></a>
                <a v-show="(current_user.company_admin && row.id !== current_user.id)  && !row.company_admin" class="list_controller glyphicon glyphicon-unchecked" title="User is Normal User" style="cursor: pointer;" @click="confirm_company_admin_toggle(row, 1)"></a>
                <a v-show="(current_user.company_admin && row.id !== current_user.id)  && row.company_admin" class="list_controller glyphicon glyphicon-check" title="User is Company Admin" style="cursor: pointer;" @click="confirm_company_admin_toggle(row, 0)"></a>
            </div>
            <div class="list_column list_column_company_admin"  v-if="$root.panel === 'admin' && list_name == 'user'" style="text-align: center;">
                <span v-show="!row.company_id">N/A</span>
                <a v-show="row.company_id && !row.company_admin" class="list_controller glyphicon glyphicon-unchecked" title="User is Normal User" style="cursor: pointer;" @click="confirm_company_admin_toggle(row, 1)"></a>
                <a v-show="row.company_id && row.company_admin" class="list_controller glyphicon glyphicon-check" title="User is Company Admin" style="cursor: pointer;" @click="confirm_company_admin_toggle(row, 0)"></a>
            </div>
<!--            <div class="list_column list_column_controller_container list_controller_container" v-if="$root.panel === 'client' && list_name == 'user'">-->
<!--                <a v-if="list_name == 'user' && (current_user.company_admin || row.id === current_user.id)" class="list_controller glyphicon glyphicon-pencil list_controller_edit" title="Edit" @click="edit_item(row)"></a>-->
<!--                <a v-if="list_name == 'user' && current_user.company_admin && row.id != $root.current_id.user" class="list_controller glyphicon glyphicon-trash list_controller_delete" title="Delete" @click="delete_item(row)"></a>-->
<!--            </div>-->
<!--            <div class="list_column list_column_controller_container list_controller_container" v-if="$root.panel === 'admin'">-->
<!--                <a v-if="list_name == 'super'" class="glyphicon glyphicon-pencil" title="Edit" @click="$root.set_page('/admin/order-super',{super_id:row.id})"></a>-->
<!--                <a v-if="list_name == 'super'" class="glyphicon glyphicon-eye-open" title="Preview" target="_blank" :href="'/admin/render_super?super_id='+row.id+'&render_type=view'"></a>-->
<!--                <a v-if="list_name == 'super'" class="glyphicon glyphicon-download-alt" title="Download" target="_blank" :download="row.name+'.doc'" :href="'/admin/render_super?super_id='+row.id+''"></a>-->
<!--  Trust Control  -->
<!--                <a v-if="list_name == 'trust'" class="glyphicon glyphicon-pencil" title="Edit" @click="$root.set_page('/admin/order-trust',{trust_id:row.id})"></a>-->
<!--                <a v-if="list_name == 'trust'" class="glyphicon glyphicon-eye-open" title="Preview" target="_blank" :href="'/admin/render_document?trust_id='+row.id+'&render_type=view'"></a>-->
<!--                <a v-if="list_name == 'trust'" class="glyphicon glyphicon-download-alt" title="Download" target="_blank" :download="row.name+'.doc'" :href="'/admin/render_document?trust_id='+row.id+''"></a>-->

<!--                <a class="glyphicon glyphicon-trash" title="Delete" v-show="show_controller('delete_item')" @click="delete_item(row)"></a>-->
<!--                <a class="glyphicon glyphicon-pencil" title="Edit" @click="edit_item(row)"></a>-->
<!--                <a class="glyphicon glyphicon-remove" title="Delete" @click="delete_item(row)"></a>-->
            <div class="list_column list_column_controller_container list_controller_container" v-if="$root.panel === 'admin' && list_name == 'bgl_company'">
                <a class="list_controller list_row_controller glyphicon glyphicon-eye-open" title="View" href="javascript:void(0)" @click="$root.set_page('/admin/view-company',{id:row.id})"></a>
                <a class="list_controller list_row_controller glyphicon glyphicon-download-alt" :href="'/admin/render_company_registraition?id='+row.id+'&render_type=mht_view'" target="_blank" :download="row.name+'.doc'"></a>
                <a v-if="!row.registered && !row.launched" class="list_controller list_row_controller glyphicon glyphicon-unchecked" title="Launched on Cas360" @click="update_item_attachment(row, 'launched', 1)"></a>
                <a v-if="!row.registered && row.launched" class="list_controller list_row_controller glyphicon glyphicon-check" title="Pending submission on Cas360" @click="update_item_attachment(row, 'launched', 0)"></a>
            </div>
            <div class="list_column list_column_controller_container list_controller_container" v-if="list_controllers['row_controller'].length">
<!--  Allen Test General Controller -->
                <template v-for="list_controller in list_controllers['row_controller']">
                <div v-if="$root.panel === 'client' && list_controller.name === 'attach' && row._ref_list_document && row._ref_list_document.length > 1" class="expand_parent" :class="{expand_parent_expanded:current_download_list === row.id}" style="position: relative;">
                    <div class="expand_trigger" @click="toggle_download_list(row)">
                        <i class="glyphicon glyphicon-download"></i>
                    </div>
                    <div class="expand_wrapper" style="position:absolute;z-index:100;right:0;left:auto;">
                        <div class="expand_container" style="background:rgba(249,249,249,1);padding:1em;border-radius:5px;">
                            <h3 style="font-weight:bold;margin:0;padding:0 0 0.5em 0;">Document Downloads</h3>
                            <ul style="padding-left: 1.5em;font-size: 0.9em;">
                                <li v-for="document in row._ref_list_document">
                                    <a style="display: flex;justify-content: space-between;align-items: center;gap: 1em;padding:0.125em 0;text-decoration: underline;color: blue;" :href="'/assets/client_download/'+document.reference_type+'/'+document.reference_id+'/'+document.name+'.'+document.extension" :download="document.display_name+'.'+document.extension">
                                        <span v-html="document.display_name+'.'+document.extension"></span>
                                        <!--                                <i class="glyphicon glyphicon-download"></i>-->
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <a v-else v-show="show_controller(list_controller.name, row)" :class="list_controller.icon_class" :title="list_controller.label" @click="list_controller.action(row)" :href="list_controller.href(row)" :download="list_controller.download(row)" :target="list_controller.target"></a>
                </template>
            </div>
        </div>
        <div class="list_bottom" v-show="filtered_list_total >= filtered_list_limit" style="display:flex;justify-content:center;padding: 2em 0;">
            <div class="btn btn-primary" @click="filtered_list_limit*=2" style="font-size: 1.4em;">Load More ...</div>
        </div>
    </div>
    <component is="style" v-html="fieldsStyle()"></component>
</div>
</template>

<script>
    export default {
        name: 'ItemList',
        props: ['option'],
        data() {
            let result = {
                filtered_list_id: 0,
                filtered_list_count: 0,             //
                filtered_list_limit: 100,           // max items displayed
                current_user:{},
                current_download_list:-1,
                filter_by_keywords:'',
                // order_by: 'id',
                // order_seq: 'desc',
                list_name: '',
                order_by_default: '',
                order_by: '',
                order_seq: 'asc',
                uri_query: {},
                message_option: {
                    message_type: 'default',
                    message: ''
                },
                fields:[],
                list_controllers:{row_controller:[],top_controller:[]},
                list_filters:{},
                show_date_filter:{},
                list_attach_document_chosen:{},
                request_module:[]
            };

            let current_object = this;
            let root = this.$root;
            let current_page = root.item_map.page[root.current_id.page];
            if (current_page.request_module) {
                result.request_module = current_page.request_module;
            }
            if (current_object.$root.current_id.user && current_object.$root.item_map.user && current_object.$root.item_map.user[current_object.$root.current_id.user]) {
                result.current_user = current_object.$root.item_map.user[current_object.$root.current_id.user];
            }
            current_object.set_list(result);
            // console.log('allen debug ItemList option',current_object.option);

            return result;
        },
        mounted() {
            let current_object = this;

            current_object.$root.flag_loading++;

            current_object.$root.load_module({
                request_module:current_object.request_module,
                call_back:function (load_result) {
                    current_object.$root.flag_loading--;
                    if (load_result) {
                        current_object.set_list();
                    }
                }
            });

            // Refetch on tab focus / visibility change so list pages
            // (My Details users, stored parties, etc.) catch updates
            // made in another tab — e.g. revoking Admin in the AML
            // Settings page won't reflect here until the user comes
            // back. Single load_module call per re-focus.
            //
            // 30 s debounce protects against rapid alt-tab cycles
            // (focus + visibilitychange can fire 5+ times in a few
            // seconds when a user flips between tabs); the cap
            // catches the cross-tab use case while keeping per-user
            // overhead low.
            const REFETCH_WINDOW_MS = 30 * 1000;
            current_object._lastRefetchAt = Date.now();
            current_object._refreshList = function () {
                if (Date.now() - current_object._lastRefetchAt < REFETCH_WINDOW_MS) return;
                current_object._lastRefetchAt = Date.now();
                current_object.$root.load_module({
                    request_module: current_object.request_module,
                    call_back: function (load_result) {
                        if (load_result) current_object.set_list();
                    }
                });
            };
            current_object._onFocus = function () { current_object._refreshList(); };
            current_object._onVisible = function () {
                if (document.visibilityState === 'visible') current_object._refreshList();
            };
            window.addEventListener('focus', current_object._onFocus);
            document.addEventListener('visibilitychange', current_object._onVisible);
        },

        beforeUnmount() {
            if (this._onFocus) window.removeEventListener('focus', this._onFocus);
            if (this._onVisible) document.removeEventListener('visibilitychange', this._onVisible);
        },
        computed: {
            filtered_list_total: function () {
                // Total matching items before slicing (for "Load More" button)
                return this._all_filtered.length;
            },
            filtered_list: function () {
                // Sliced version for display
                return this._all_filtered.slice(0, this.filtered_list_limit);
            },
            _all_filtered: function () {
                let result = [];
                let current_object = this;
                if (!current_object.list) {
                    return result;
                }

                let keywords = current_object.filter_by_keywords.toLowerCase();

                let date_filter = {};
                Object.keys(current_object.list_filters).forEach(function (field_name) {
                    if (current_object.list_filters[field_name] && current_object.list_filters[field_name].length && typeof current_object.show_date_filter[field_name] !== 'undefined') {
                        date_filter[field_name] = {
                            start: null,
                            end: null
                        };
                        if (current_object.list_filters[field_name][0]) {
                            date_filter[field_name].start = new Date(current_object.list_filters[field_name][0]+'T00:00:00');
                        }
                        if (current_object.list_filters[field_name][1]) {
                            date_filter[field_name].end = new Date(current_object.list_filters[field_name][1]+'T23:59:59');
                        }
                    }
                });

                current_object.list.forEach(function (item) {
                    // if (current_object.filtered_list_count >= current_object.filtered_list_limit) {
                    //     return;
                    // }

                    // Client panel: never render soft-deleted rows. The server
                    // still ships them in item_list so the local store knows
                    // about the trash state (and a re-add can trigger a
                    // restore-rather-than-duplicate on the backend), but the
                    // user shouldn't see them. Admin keeps them visible so the
                    // Restore controller at line ~816 stays reachable.
                    if (item.deleted_at && current_object.$root.panel === 'client') {
                        return;
                    }

                    let flag_match = true;
                    if (keywords.length > 1) {
                        flag_match = false;
                        current_object.fields.every(function (field) {
                            if (!field.keywords_search) return true;
                            if (field.keywords_search === 'exact' && item[field.name] == keywords) {
                                flag_match = true;
                                return false;
                            }
                            if (field.keywords_search === 'word' && (item[field.name].toLowerCase().indexOf(keywords) === 0 || item[field.name].toLowerCase().indexOf(' '+keywords) !== -1)) {
                                flag_match = true;
                                return false;
                            }
                            if (field.keywords_search === 'free_text' && item[field.name].toLowerCase().indexOf(keywords) >= 0) {
                                flag_match = true;
                                return false;
                            }
                            if (field.keywords_search === 'formatted_content') {
                                let row_formatted_content = current_object.formatted_content(item,field);
                                if (typeof row_formatted_content === 'number') {
                                    row_formatted_content = row_formatted_content.toString();
                                }
                                if (typeof row_formatted_content !== 'string') {
                                    return true;
                                }
                                row_formatted_content = row_formatted_content.toLowerCase();
                                if (row_formatted_content.indexOf(keywords) === 0 || row_formatted_content.indexOf(' '+keywords) >= 0) {
                                    flag_match = true;
                                    return false;
                                }
                            }

                            return true;
                        });
                        if (!flag_match) {
                            return;
                        }
                    }
                    Object.keys(current_object.list_filters).forEach(function (field_name) {
                        // if (current_object.list_filters[field_name] !== '_all') {
                        //     if (typeof item[field_name] !== 'undefined') {
                        //         flag_match = flag_match && (item[field_name] == current_object.list_filters[field_name]);
                        //     } else {
                        //         switch (field_name) {
                        //             case 'company_id':
                        //                 if (item._ref_user) {
                        //                     // console.log('item[field_name]',field_name,item._ref_user,item,current_object);
                        //                     flag_match = flag_match && (item._ref_user[field_name] == current_object.list_filters[field_name]);
                        //                 } else {
                        //                     flag_match = false;
                        //                 }
                        //                 break;
                        //         }
                        //     }
                        // }
                        if (current_object.list_filters[field_name] && current_object.list_filters[field_name].length) {
                            if (typeof item[field_name] !== 'undefined') {
                                if (typeof current_object.show_date_filter[field_name] !== 'undefined') {
                                    let item_date = new Date(item[field_name]+'Z');
                                    if (date_filter[field_name].start && item_date < date_filter[field_name].start) {
                                        flag_match = false;
                                    }
                                    if (date_filter[field_name].end && item_date > date_filter[field_name].end) {
                                        flag_match = false;
                                    }
                                } else {
                                    flag_match = flag_match && (current_object.list_filters[field_name].indexOf(String(item[field_name])) !== -1);
                                }
                            } else {
                                switch (field_name) {
                                    case 'company_id':
                                        if (item._ref_user) {
                                            flag_match = flag_match && (current_object.list_filters[field_name].indexOf(String(item._ref_user[field_name])) !== -1);
//                                          flag_match = flag_match && (item._ref_user[field_name] == current_object.list_filters[field_name]);

                                        } else {
                                            flag_match = false;
                                        }
                                        break;
                                }
                            }
                        }
                    });
                    if (!flag_match) {
                        return;
                    }

                    if (item._ref_list_document) {
                        item._current_chosen_document_index = 0;
                    }

                    result.push(item);
                });
                let field_order_by = current_object.order_by;
                if (result[0] && result[0]['_order_'+current_object.order_by]) {
                    field_order_by = '_order_'+current_object.order_by;

                }
                result = _.orderBy(result, field_order_by, current_object.order_seq);
                // Return full sorted result; slicing is done in filtered_list computed

                if (current_object.scroll_top) {
                    setTimeout(function () {
                        if (current_object.scroll_top) {
                            $('#app').scrollTop(current_object.scroll_top);
                            delete current_object.scroll_top;
                        }
                    },200);
                }

                return result;
            }
        },
        methods: {
            set_list: function (data_object) {
                if (typeof data_object === 'undefined') {
                    data_object = this;
                }
                let current_object = this;
                let root = this.$root;
                let current_page = root.item_map.page[root.current_id.page];
                // TODO: data_object.list, clone $root list (possibly only set related fields) and set up fields for sort and search (e.g. name, description go lower case, updated_at go updated_date)
                root.flag_loading++;
                current_object.uri_query = current_object.$root.uri_query_decoder();
                if (current_object.$root.panel === 'admin') {
                    data_object.list = root.item_list[current_page.list_name];
                } else {
                    if (current_object.$root.panel === 'client') {
                        switch (current_page.list_name) {
                            case 'user':
                                let current_user = data_object.current_user;
                                if (current_user.company_id && current_object.$root.item_map.company[current_user.company_id]) {
                                    data_object.list = current_object.$root.item_map.company[current_user.company_id]._ref_list_user;
                                    // let company_admin_id_set = [];
                                    // data_object.list.forEach(function (company_user) {
                                    //     if (company_user.company_admin) {
                                    //         company_admin_id_set.push(company_user.id);
                                    //     }
                                    // });
                                    // if (company_admin_id_set.length === 0 && data_object.list[0]) {
                                    //     data_object.list[0].company_admin = 1;
                                    //     current_object.update_item_attachment(data_object.list[0], 'company_admin', 1, current_page.list_name);
                                    // }
                                } else {
                                    data_object.list = [current_user];
                                }
                                break;
                            default:
                                data_object.list = root.item_list[current_page.list_name];
                        }
                    }
                }
                if (data_object.list) {
                    data_object.list_name = current_page.list_name;
                }

                if (!data_object.fields) {
                    data_object.fields = [];
                }

                if (!data_object.fields.length && root.item_field[current_page.list_name]) {
                    let list_field_name_list;
                    if (current_page.list_field) {
                        list_field_name_list = current_page.list_field;
                    } else {
                        list_field_name_list = ['id','name','created_at','updated_at'];
                    }
                    if (current_page.order_by) {
                        data_object.order_by = current_page.order_by;
                        data_object.order_by_default = current_page.order_by;

                        if (current_page.order_seq) {
                            data_object.order_seq = current_page.order_seq;
                        }
                    }

                    // Assume all keywords searchable fields are in list_field_name_list
                    data_object.list_filters = {};
                    data_object.show_date_filter = {};
                    current_object.filter_map = {};     // For indirect field filter id mapping
                    list_field_name_list.forEach(function (field_name) {
                        let field_option = {};
                        if (typeof field_name === 'object' && field_name.name) {
                            field_option = field_name;
                            field_name = field_name.name;
                        }
                        let scope_field;
                        if (!root.item_field[current_page.list_name][field_name]) {
                            switch (field_name) {
                                case 'company_id':
                                    // If company_id is not in current list items but user_id is, create an indirect scope_field for filter
                                    scope_field = Object.assign({}, root.item_field['user']['company_id'], field_option);
                                    break;
                                default:
                                    return false;

                            }
                        } else {
                            scope_field = Object.assign({}, root.item_field[current_page.list_name][field_name], field_option);
                        }

                        data_object.fields.push(scope_field);
                        if (!data_object.order_by) {
                            data_object.order_by = field_name;
                            data_object.order_by_default = field_name;
                            data_object.order_seq = 'asc';
                            if (current_object.uri_query['order_seq']) {
                                data_object.order_seq = current_object.uri_query['order_seq'];
                            } else {
                                if (root.item_field[current_page.list_name][field_name].order_seq_default) {
                                    data_object.order_seq = root.item_field[current_page.list_name][field_name].order_seq_default;
                                }
                            }
                        }
                        if (current_object.uri_query['order_by'] && current_object.uri_query['order_by'] === field_name) {
                            data_object.order_by = current_object.uri_query['order_by'];
                            if (current_object.uri_query['order_seq']) {
                                data_object.order_seq = current_object.uri_query['order_seq'];
                            } else {
                                data_object.order_seq = root.item_field[current_page.list_name][field_name].order_seq_default;
                            }
                        }

                        if (scope_field.field_available_options) {
                            scope_field.field_available_options = _.orderBy(scope_field.field_available_options, 'name', 'asc');
                            if (typeof current_object.uri_query[field_name] !== 'undefined') {
                                data_object.list_filters[field_name] = current_object.uri_query[field_name].split(',');
                                console.log('Uri set filter data_object.list_filters[field_name]',field_name,typeof data_object.list_filters[field_name],data_object.list_filters[field_name]);
                            } else {
                                data_object.list_filters[field_name] = [];
                            }
                        }
                        if (scope_field.field_type === 'datetime-local') {
                            data_object.show_date_filter[field_name] = '';
                            if (typeof current_object.uri_query[field_name] !== 'undefined') {
                                data_object.list_filters[field_name] = current_object.uri_query[field_name].split(',');
                                console.log('Uri set filter data_object.list_filters[field_name]',field_name,typeof data_object.list_filters[field_name],data_object.list_filters[field_name]);
                            } else {
                                data_object.list_filters[field_name] = [];
                            }
                        }
                            /*switch (field_name) {
                                case 'user_id':
                                    if (!root.item_field['user']) {
                                        break;
                                    }
                                    console.log('scope_field.field_available_options',scope_field.field_available_options,data_object.fields);
                                    // current_object.filter_map['company_id'] = {'field_name':field_name,'id_map':{}};
                                    // scope_field.field_available_options.forEach(function (option_item) {
                                    //     let item_object = current_object.$root.item_map[field_name][option_item['id']];
                                    //     if (item_object.company_id) {
                                    //         option_item.company_id = item_object.company_id;
                                    //     }
                                    //
                                    // });
                                    let scope_field = Object.assign({}, root.item_field['user']['company_id'], field_option);

                                    data_object.fields.push(scope_field);
                                    if (!data_object.order_by) {
                                        data_object.order_by = field_name;
                                        data_object.order_seq = 'asc';
                                        if (root.item_field[current_page.list_name][field_name].order_seq_default) {
                                            data_object.order_seq = root.item_field[current_page.list_name][field_name].order_seq_default;
                                        }
                                    }
                                    if (scope_field.field_available_options) {
                                        scope_field.field_available_options = _.orderBy(scope_field.field_available_options, 'name', 'asc');
                                        data_object.list_filters[field_name] = '_all';
                                    }
                                    break;

                            }*/

                    });

                    if (current_object.$root.panel === 'client' && data_object.list_name === 'user') {
                        // Empty array (not null) — downstream filter checks
                        // do list_filters[field_name].length and null.length
                        // throws, which on a hot computed cascades into Vue
                        // render warnings that can break unrelated children.
                        data_object.list_filters['deleted_at'] = [];
                    }
                    // if (current_object.$root.panel === 'admin' && typeof data_object.list_filters('user_id') !== 'undefined') {
                    //     let scope_field = Object.assign({}, root.item_field[current_page.list_name]['company_id'], field_option);
                    //
                    //     data_object.fields.push(scope_field);
                    //     if (!data_object.order_by) {
                    //         data_object.order_by = 'company_id';
                    //         data_object.order_seq = 'asc';
                    //         if (root.item_field[current_page.list_name]['company_id'].order_seq_default) {
                    //             data_object.order_seq = root.item_field[current_page.list_name]['company_id'].order_seq_default;
                    //         }
                    //     }
                    //     if (scope_field.field_available_options) {
                    //         scope_field.field_available_options = _.orderBy(scope_field.field_available_options, 'name', 'asc');
                    //         data_object.list_filters['company_id'] = '_all';
                    //     }
                    // }
                }
                if (!data_object.list_controllers) {
                    data_object.list_controllers = {row_controller:[],top_controller:[]};
                } else {
                    data_object.list_controllers['row_controller'].splice(0,data_object.list_controllers['row_controller'].length);
                    data_object.list_controllers['top_controller'].splice(0,data_object.list_controllers['top_controller'].length);
                }
                if (current_page.list_controllers) {
                    current_page.list_controllers.forEach(function (list_controller) {
                        let default_option = {};
                        if (typeof list_controller === 'string') {
                            list_controller = {name:list_controller};
                        }
                        if (list_controller.name) {
                            default_option.label = current_object.$root.fix_format(list_controller.name,['display_name']);
                            default_option.action = current_object[list_controller.name+'_item'];           // e.g. edit_item, delete_item
                            if (typeof default_option.action !== 'function') {
                                default_option.action = function () {return false;}
                            }
                            default_option.controller_type = 'row_controller';
                            default_option.icon_class = 'glyphicon list_controller list_controller_'+list_controller.name;
                            default_option.href = function (row) {
                                return current_object.item_href(row, list_controller.name);
                            };
                            default_option.download = function (row) {
                                return current_object.item_download(row, list_controller.name);
                            };
                            default_option.target = null;
                            switch (list_controller.name) {
                                case 'add':
                                    default_option.controller_type = 'top_controller';
                                    default_option.label = 'Create New '+ current_object.$root.fix_format(data_object.list_name,['display_name']);
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-plus';
                                    break;
                                case 'attach':
                                    if (current_object.$root.panel === 'admin') {
                                        default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-paperclip';
                                    } else {
                                        default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-download';
                                        default_option.target = '_blank';
                                    }

                                    break;
                                case 'custom_theme_add':
                                    default_option.label = 'Create Custom Theme Page';
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-unchecked';
                                    break;
                                case 'custom_theme_edit':
                                    default_option.label = 'Edit Custom Theme Page';
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-edit';
                                    break;
                                case 'delete':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-trash';
                                    break;
                                case 'diagram':
                                    // Opens the FTE distribution diagram / analyser
                                    // in a new tab. The default item_href already
                                    // yields /admin/diagram-fte-review?id=<id>.
                                    // Uses a Bootstrap Icons glyph directly
                                    // (bi-diagram-3 = connected nodes): the site's
                                    // glyphicon compat subset has no chart/diagram
                                    // icon, so glyphicon-* would render blank.
                                    default_option.label = 'Distribution Diagram';
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' bi bi-diagram-3';
                                    default_option.target = '_blank';
                                    break;
                                case 'download':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-download-alt';
                                    default_option.target = '_blank';
                                    break;
                                case 'edit':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-pencil';
                                    break;
                                case 'order_completed':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-check';
                                    default_option.action = function (row) {
                                        if (row.id) {current_object.update_item(row, 'order_status', 'pending');}
                                    };
                                    break;
                                case 'order_pending':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-unchecked';
                                    default_option.action = function (row) {
                                        if (row.id) {
                                            current_object.update_item(row, 'order_status', 'completed', current_object.list_name, confirm('An email is about be sent to the client notifying them the order is complete.'));
                                        }
                                    };
                                    break;
                                case 'preview' :
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-list-alt';
                                    default_option.target = '_blank';
                                    break;
                                case 'restore':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-export';
                                    break;
                                case 'view':
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-eye-open';
                                    default_option.href = function () {
                                        return 'javascript:void(0);';
                                    }
                                    // default_option.target = '_blank';
                                    break;
                                default:
                                    default_option.icon_class += ' list_' + default_option.controller_type + ' glyphicon-asterisk';
                            }
                        }
                        list_controller = Object.assign(default_option,list_controller);

                        data_object.list_controllers[list_controller.controller_type].push(list_controller);
                    });
                }

                if (!data_object.filter) {
                    data_object.filter = [];
                }
                if (current_page.list_filter ) {
                // <div class="admin_list_filter">
                //         <label>Filter by Company:</label>
                //     <select v-model="filter_by_company">
                //         <option value="0" v-html="filter_by_company==0?'-- Filter by Company --':'-- Display All --'"></option>
                //         <option value="-1">-- Independent Users --</option>
                //     <option v-for="company in sorted_companies" :value="company.id">{{ company.description }}</option>
                //     </select>
                //     </div>
                //     {
                //         'field':'type',
                //         'label':'Filter by Type',
                //         'placeholder':'-- Filter by Type --',
                //         'option':[
                //         {'value':'DT','display_name':'Discretionary Trust'},
                //         {'value':'HDT','display_name':'Hybrid Discretionary Trust'},
                //         {'value':'CDT','display_name':'Class Discretionary Trust'},
                //         {'value':'CVT','display_name':'Capital Vested Trust'},
                //         {'value':'UT','display_name':'Unit Trust'},
                //         {'value':'HUT','display_name':'Hybrid Unit Trust'},
                //         {'value':'LTUT','display_name':'NSW Land Tax Unit Trust'},
                //         {'value':'WAPUT','display_name':'WA Property Unit Trust'},
                //         {'value':'VICPUT','display_name':'VIC Property Unit Trust'}
                //     ]
                //     }

                }
                root.flag_loading--;

                return data_object;
            },
            formatted_content: function (data_row, field) {
                let current_object = this;
                if (['register_company','super','trust'].indexOf(current_object.list_name) > -1) {
                    if (['type','variation'].indexOf(field.name) > -1) {
                        return data_row[field.name];
                    }
                }
                let result = data_row[field.name];
                if (typeof data_row[field.name] === 'undefined') {
                    switch (field.name) {
                        case 'company_id':
                            if (data_row['user_id'] && data_row._ref_user) {
                                result = data_row._ref_user[field.name];
                            }
                            break;
                    }
                }
                switch (typeof field.formatted_content) {
                    case 'object':
                        if (typeof field.formatted_content[result] !== 'undefined') {
                            return field.formatted_content[result];
                        }
                        return result;
                        break;
                    case 'function':
                        result = field.formatted_content(result);
                        if (typeof result === 'number') {
                            result = result.toString();
                        }
                        return result;
                        break;
                    case 'undefined':
                    default:
                        return result;

                }
            },
            show_controller: function(controller_name, data_row) {
// console.log('show_controller',controller_name,data_row);
                let current_object = this;
                let flag_show_controller = true;
                if (current_object.$root.panel === 'client' && current_object.list_name === 'user') {
                    flag_show_controller = false;
                }
                switch (controller_name) {
                    case 'add':
                        if (current_object.$root.panel === 'client' && current_object.list_name === 'user') {
                            if (current_object.current_user && current_object.current_user._ref_company) {
                                if (current_object.current_user.company_admin) {
                                    flag_show_controller = true;
                                }
                            }
                        }
                        break;
                    case 'attach':
                        if (current_object.$root.panel === 'admin') {
                            flag_show_controller = true;
                        } else {
                            flag_show_controller = false;
                            if (data_row._ref_list_document && data_row._ref_list_document.length) {
                                flag_show_controller = true;
                            }
                        }
                        break;
                    case 'custom_theme_add':
                        return (!data_row._ref_list_custom_theme || !data_row._ref_list_custom_theme.length);
                    case 'custom_theme_edit':
                        return (data_row._ref_list_custom_theme &&  data_row._ref_list_custom_theme.length);
                    case 'delete':
                        if (data_row && data_row.deleted_at) {
                            // what is dead cannot be killed
                            return false;
                        }

                        if (current_object.$root.panel === 'client' && current_object.list_name === 'user') {
                            return (current_object.current_user && data_row.id != current_object.current_user.id && current_object.current_user.company_admin);
                        }
                        break;
                    case 'edit':
                        if (data_row && data_row.deleted_at) {
                            return false;
                        }
                        if (current_object.$root.panel === 'client' && current_object.list_name === 'user') {
                            return (current_object.current_user && (data_row.id == current_object.current_user.id || current_object.current_user.company_admin));
                        }
                        break;
                    case 'filter':
                        if (current_object.$root.panel === 'client' && current_object.list_name === 'user') {
                            return false;
                        }
                        break;
                    case 'order_completed':
                        return (data_row.order_status === 'completed');
                    case 'order_pending':
                        return (data_row.order_status !== 'completed');
                    case 'restore':
                        flag_show_controller = false;
                        if (current_object.$root.panel === 'admin' && data_row && data_row.deleted_at && current_object.list_name === 'user') {
                            return true;
                        }
                        break;
                }
                return flag_show_controller;

            },
            // filter_change: function(field_name) {
            //     // Re-compute filtered_list
            //     // changing dynamic generated dropdown filter that loaded on ajax callback would not trigger computed filtered_list change, use an extra param to refresh it
            //     let current_object = this;
            //     current_object.filtered_list_id ++;
            //     if (current_object.list_filters[field_name] === '_all') {
            //         delete current_object.uri_query[field_name];
            //     } else {
            //         current_object.uri_query[field_name] = current_object.list_filters[field_name];
            //     }
            //     current_object.$root.set_page('',current_object.uri_query,{'update_state':'replaceState',scroll_top:true});
            //
            //     // console.log('Filter changed: ',field_name,current_object.list_filters[field_name]);
            //     // return this.filtered_list;
            // },
            date_filter_attribute: function(field_name, input_attribute) {
                let current_object = this;
                if (!current_object.show_date_filter[field_name]) {
                    return '';
                }
                switch (input_attribute) {
                    case 'max':
                        if (!current_object.list_filters[field_name].length || !current_object.list_filters[field_name][1] || current_object.show_date_filter[field_name] === 'end_date') {
                            return '';
                        }
                        return current_object.list_filters[field_name][1];
                        break;
                    case 'min':
                        if (!current_object.list_filters[field_name].length || !current_object.list_filters[field_name][0] || current_object.show_date_filter[field_name] === 'start_date') {
                            return '';
                        }
                        return current_object.list_filters[field_name][0];
                        break;
                }
            },
            date_filter_change: function(field_name, event) {
                let current_object = this;

                switch(event.target.value) {
                    case '_all':
                        current_object.set_filter(field_name,'clear_date');
                        event.target.value = '';
                        break;
                    case 'current_month':
                    case 'last_month':
                        current_object.set_filter(field_name,event.target.value);
                        event.target.value = '';
                        break;
                    case 'start_date':
                    case 'end_date':
                        break;
                }
            },
            set_filter: function(field_name, field_type, event) {
                console.log('set_filter',field_name, field_type, event);
                // console.log('fill_form_from_stored',event);
                let current_object = this;
                switch (field_type) {
                    case 'select':
                        if (event.target.value === '_all') {
                            current_object.list_filters[field_name].splice(0, current_object.list_filters[field_name].length);
                            delete current_object.uri_query[field_name];
                        } else {
                            let current_value = String(event.target.value);
                            let current_value_index = current_object.list_filters[field_name].indexOf(current_value);
                            if (current_value_index === -1) {
                                current_object.list_filters[field_name].push(current_value);
                            } else {
                                current_object.list_filters[field_name].splice(current_value_index,1);
                            }
                            current_object.list_filters[field_name].sort();
                            current_object.uri_query[field_name] = current_object.list_filters[field_name].join(',');
                        }
                        break;
                    case 'clear_date':
                        current_object.list_filters[field_name].splice(0, current_object.list_filters[field_name].length, '', '');
                        delete current_object.uri_query[field_name];
                        break;
                    case 'start_date':
                        current_object.show_date_filter[field_name] = '';
                        current_object.list_filters[field_name].splice(0, 1, event.target.value);
                        current_object.uri_query[field_name] = current_object.list_filters[field_name].join(',');
                        break;
                    case 'end_date':
                        current_object.show_date_filter[field_name] = '';
                        while (current_object.list_filters[field_name].length < 2) {
                            current_object.list_filters[field_name].push('');
                        }
                        current_object.list_filters[field_name].splice(1, 1, event.target.value);
                        current_object.uri_query[field_name] = current_object.list_filters[field_name].join(',');
                        break;
                    case 'last_month':
                    case 'current_month':

                        let end_date = new Date();
                        if (field_type === 'current_month') {
                            end_date.setMonth(end_date.getMonth()+1);
                        }
                        end_date.setDate(0);
                        let month_string = ('0'+(end_date.getMonth()+1)).slice(-2);
                        current_object.list_filters[field_name] = [end_date.getFullYear()+'-'+month_string+'-01',end_date.getFullYear()+'-'+month_string+'-'+('0'+end_date.getDate()).slice(-2)];
                        current_object.uri_query[field_name] = current_object.list_filters[field_name].join(',');
                        break;

                }

                current_object.$root.set_page('',current_object.uri_query,{'update_state':'replaceState',scroll_top:true});

                if (event) {
                    event.target.value = '';
                }
            },
            formatted_filter_value: function(field_name) {
                let current_object = this;
                let result = '';
                if (!current_object.list_filters[field_name].length) {
                    return '';
                }
                let selected_name_list = [];
                console.log('formatted_filter_value',field_name,current_object.fields,current_object.list_filters[field_name]);
                current_object.fields.forEach(function (field) {
                    if (field.name === field_name) {
                        if (field.field_available_options) {
                            field.field_available_options.forEach(function (field_available_option) {
                                if (current_object.list_filters[field_name].indexOf(String(field_available_option.id)) > -1) {
                                    selected_name_list.push(field_available_option.name);
                                }
                            });
                            // result = current_object.$root.fix_format(selected_name_list,['item_list_formatted_name']);
                            for (let i=0;i<selected_name_list.length;i++) {
                                if (i > 0) {
                                    if (i >= selected_name_list.length - 1) {
                                        result += ' and ';
                                    } else {
                                        result += ', ';
                                    }
                                }
                                result += selected_name_list[i];
                            }
                        }

                        if (field.field_type === 'datetime-local') {
                            result = current_object.$root.fix_format(current_object.list_filters[field_name],['range','date']);
                        }
                    }
                });


                return result;
            },
            item_download: function(row, action) {
                // reference to <a> tag download attribute, works for download link only, attribute value is the download file name with extension. e.g. "Example Document.pdf"
                if (!row || !action) {
                    return null;
                }
                let current_object = this;
                switch (action) {
                    case 'attach':
                        if (current_object.$root.panel === 'client') {
                            if (row._ref_list_document && row._ref_list_document[row._current_chosen_document_index]) {
                                let current_document_item = row._ref_list_document[row._current_chosen_document_index];
                                return current_document_item.display_name+'.'+current_document_item.extension;
                                break;
                            }
                        }
                        break;
                    case 'download':
                        switch (current_object.list_name) {
                            case 'gift_deed':
                                return row.name+' - Deed of Gift.doc';
                            case 'loan_agreement':
                                return row.name+' - Deed of Loan.doc';
                            case 'register_company':
                            case 'super':
                            case 'trust':
                                return row.name+'.doc';
                        }
                        break;
                }
                return null;
            },
            item_href: function(row, action) {
                if (!row || !action) {
                    return null;
                }
                let current_object = this;
                let result = '/'+current_object.$root.panel+'/'+action+'-'+current_object.list_name.replace('_','-')+'?id='+row.id;
                switch (action) {
                    case 'attach':
                        if (current_object.$root.panel === 'client') {
                            if (row._ref_list_document && row._ref_list_document[row._current_chosen_document_index]) {
                                let current_document_item = row._ref_list_document[row._current_chosen_document_index];
                                result = '/assets/client_download/'+current_document_item.reference_type+'/'+current_document_item.reference_id+'/'+current_document_item.name+'.'+current_document_item.extension;
                                break;
                            }
                        }
                    case 'edit':
                    case 'custom_theme_add':
                    case 'custom_theme_edit':
                    case 'delete':
                    case 'restore':
                    case 'order_completed':
                    case 'order_pending':
                    case 'view':
                        result = '';
                        break;
                    case 'preview':
                        switch (current_object.list_name) {
                            case 'gift_deed':
                                result = '/'+current_object.$root.panel+'/render_gift_deed?id='+row.id;
                                break;
                            case 'loan_agreement':
                                result = '/'+current_object.$root.panel+'/render_loan_agreement?id='+row.id;
                                break;
                            case 'register_company':
                                result = '/'+current_object.$root.panel+'/render_register_company?id='+row.id;
                                break;
                            case 'super':
                                result = '/'+current_object.$root.panel+'/render_super?super_id='+row.id;
                                break;
                            case 'trust':
                                result = '/'+current_object.$root.panel+'/render_document?trust_id='+row.id;
                                break;
                            default:
                        }
                        result += '&render_type=view';
                        break;
                    case 'download':
                        switch (current_object.list_name) {
                            case 'gift_deed':
                                result = '/'+current_object.$root.panel+'/render_gift_deed?id='+row.id;
                                break;
                            case 'loan_agreement':
                                result = '/'+current_object.$root.panel+'/render_loan_agreement?id='+row.id;
                                break;
                            case 'register_company':
                                result = '/'+current_object.$root.panel+'/render_register_company?id='+row.id;
                                break;
                            case 'super':
                                result = '/'+current_object.$root.panel+'/render_super?super_id='+row.id;
                                break;
                            case 'trust':
                                result = '/'+current_object.$root.panel+'/render_document?trust_id='+row.id;
                                break;
                            default:
                        }
                        break;
                    default:
                }

                if (result) {
                    return result;
                }
                return 'javascript:void(0)';
            },
            add_item: function () {
                let current_object = this;
                // TODO: set_page according to list_name
                let uri_pathname = '/'+current_object.$root.panel+'/update-'+current_object.list_name.replace('_','-');


                switch (current_object.list_name) {
                    case 'gift_deed':
                    case 'loan_agreement':
                    case 'super':
                    case 'trust':
                        uri_pathname = '/'+current_object.$root.panel+'/order-'+current_object.list_name.replace('_','-');
                        break;
                    case 'bgl_company':
                    case 'register_company':
                        uri_pathname = '/'+current_object.$root.panel+'/order-company';
                        break;
                    case 'user':
                        if (current_object.$root.panel === 'client') {
                            current_object.$emit('update:item_id','new');
                            return;
                        }
                        break;
                    default:
                        if (!current_object.$root.item_map['uri_pathname'][uri_pathname]) {
                            alert('Add button for '+current_object.list_name+' is not ready yet. PS: You Know Who to Call');
                            return;
                        }

                }

                current_object.$root.set_page(uri_pathname);
                // if (!this.$root.uri_query.action || this.$root.uri_query.action !== 'add_show') {
                //     this.$root.setTab(this.$root.current_tab,{action:'add_show'});
                // }
            },
            attach_item: function (row) {
                let current_object = this;
                if (current_object.$root.panel === 'client') {
                    return false;
                }
                let uri_pathname = '/'+current_object.$root.panel+'/update-document';
                let uri_query = {type:current_object.list_name, id:row.id};
                if (!current_object.$root.item_map['uri_pathname'][uri_pathname]) {
                    alert('Attach button for '+current_object.list_name+' is not ready yet. PS: You Know Who to Call');
                    return;
                }
                current_object.$root.set_page(uri_pathname,uri_query);
            },
            custom_theme_add_item: function (row) {
                let current_object = this;
                if (current_object.$root.panel === 'client') {
                    return false;
                }
                let uri_pathname = '/'+current_object.$root.panel+'/update-custom-theme';
                let uri_query = {company_id:row.id};
                current_object.$root.set_page(uri_pathname,uri_query);
            },
            custom_theme_edit_item: function (row) {
                let current_object = this;
                if (current_object.$root.panel === 'client') {
                    return false;
                }
                let uri_pathname = '/'+current_object.$root.panel+'/update-custom-theme';
                if (!row._ref_list_custom_theme || !row._ref_list_custom_theme.length) {
                    console.log('Error, cannot find referenced theme',row._ref_list_custom_theme);
                    return;
                }
                let uri_query = {id:row._ref_list_custom_theme[0].id};
                current_object.$root.set_page(uri_pathname,uri_query);
            },
            delete_item: function (row) {
                let current_object = this;
                if (!confirm('Are you sure you want to delete this '+current_object.list_name+'?')) {
                    return false;
                }
                let post_value = {
                    item: current_object.list_name,
                    id: row.id
                };
                axios.post('/'+current_object.$root.panel+'/delete_item', post_value)
                    .then(function (response) {
                        if (response.data) {
                            if (response.data.status) {
                                switch (response.data.status) {
                                    case 'OK':
                                        current_object.message_option.message_type = 'success';
                                        current_object.$root.set_item_list(response.data.item_list);
                                        // Also remove from component's own list to ensure UI update
                                        // in case the component list reference has diverged from root
                                        if (current_object.list) {
                                            let row_index = current_object.list.indexOf(row);
                                            if (row_index !== -1) {
                                                current_object.list.splice(row_index, 1);
                                            }
                                        }
                                        break;
                                    case 'PERMISSION_DENIED':
                                        current_object.message_option.message_type = 'warning';
                                        break;
                                    default:
                                        current_object.message_option.message_type = 'error';
                                }
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                    if (current_object.message_option.message_type === 'success') {
                                        // hide message on successful login - required by MM
                                        current_object.message_option.message = '';
                                    }
                                }

                            } else {
                                current_object.message_option.message_type = 'error';
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                } else {
                                    current_object.message_option.message = 'System error, unable to login';
                                }
                            }
                        }

                    })
                    .catch(function (error) {
                        console.log('delete_item error',error);
                    });
            },
            download_item: function (row) {
                // download controllers default @click do nothing, instead, change href and download attributes
                return false;
            },
            edit_item: function (row) {
                // Change page, normally to related form page, DOES NOT update server database in this function
                let current_object = this;
                let uri_query = {};
                // TODO: set_page according to list_name
                switch (current_object.list_name) {
                    case 'gift_deed':
                        uri_query['id'] = row.id;
                        current_object.$root.set_page('/'+current_object.$root.panel+'/update-'+current_object.list_name.replace('_','-'),uri_query);
                        break;
                    case 'loan_agreement':
                        uri_query['id'] = row.id;
                        current_object.$root.set_page('/'+current_object.$root.panel+'/order-'+current_object.list_name.replace('_','-'),uri_query);
                        break;
                    case 'super':
                    case 'trust':
                        uri_query[current_object.list_name+'_id'] = row.id;
                        current_object.$root.set_page('/'+current_object.$root.panel+'/order-'+current_object.list_name,uri_query);
                        break;
                    case 'register_company':
                        uri_query['id'] = row.id;
                        current_object.$root.set_page('/'+current_object.$root.panel+'/order-company',uri_query);
                        break;
                    case 'bgl_company':
                        break;
                    case 'user':
                        switch (current_object.$root.panel) {
                            case 'admin':
                                // Set Page
                                uri_query['id'] = row.id;
                                current_object.$root.set_page('/'+current_object.$root.panel+'/update-'+current_object.list_name,uri_query);
                                break;
                            case 'client':
                                // current_object.$root.set_page(null,{id:row.id},{update_state:'replaceState',scroll_top:false});
                                current_object.$emit('update:item_id',row.id);
                                break;

                        }
                        break;
                    // case 'tv_show':
                    //     uri_query['id'] = row.id;
                    //     current_object.$root.set_page('/'+current_object.$root.panel+'/update-tv-show',uri_query);
                    //
                    //     break;
                    default:
                        uri_query['id'] = row.id;
                        current_object.$root.set_page('/'+current_object.$root.panel+'/update-'+current_object.list_name.replace('_','-'),uri_query);

                }
            },
            update_item: function (row, field, value, item, flag_send_email) {
                // Quick update (AJAX POST to server) on related row, update single field or attached data, normally for FLAG field
                let current_object = this;
                if (typeof item === 'undefined') {
                    item = current_object.list_name;
                }

                if (typeof row[field] === 'undefined') {
                    row[field] = '';
                    current_object.$forceUpdate();
                }

                let post_data = {
                    render_type:'json',
                    form_id:'list_update_'+item,
                    skip_order_record: true,
                    data_row:{},
                };
                if (current_object.$root.current_id.user) {
                    post_data.user_id = current_object.$root.current_id.user;          // Applicant user_id, generally used for Admin Panel
                }
                if (flag_send_email) {
                    post_data.send_complete_email = true;
                }

                let data_update_row = {};
                data_update_row['id'] = row.id;
                data_update_row[field] = value;
                post_data.data_row[item] = [data_update_row];

                axios.post('/'+current_object.$root.panel+'/update_item', post_data)
                    .then(function (response) {
                        if (response.data) {
                            if (response.data.status) {
                                switch (response.data.status) {
                                    case 'OK':
                                        current_object.message_option.message_type = 'success';
                                        current_object.$root.set_item_list(response.data.item_list);
                                        current_object.$forceUpdate();
                                        break;
                                    case 'PERMISSION_DENIED':
                                        current_object.message_option.message_type = 'warning';
                                        break;
                                    default:
                                        current_object.message_option.message_type = 'error';
                                }
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                    if (current_object.message_option.message_type === 'success') {
                                        // hide message on successful login - required by MM
                                        current_object.message_option.message = '';
                                    }
                                }

                            } else {
                                current_object.message_option.message_type = 'error';
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                } else {
                                    current_object.message_option.message = 'System error, unable to login';
                                }
                            }
                        }

                    })
                    .catch(function (error) {
                        console.log('update_item error',error);
                    });

            },
            confirm_company_admin_toggle: function (row, value) {
                // Wrapper around update_item_attachment for the company_admin
                // toggle. The legacy "Company Admin" flag is now two-way
                // synced with the AML platform's Admin role (Phase 8 / 2026-05-02
                // — see AmlUserRole boot-hook + DataAttachment saved hook).
                // Prompt the operator before firing so they understand the
                // cross-platform effect and the permissions involved.
                const isGrant = Number(value) === 1;
                const target  = row.formatted_name || row.name || row.email || ('user #' + row.id);
                const verb    = isGrant ? 'Grant' : 'Revoke';
                const msg     = verb + " Company Admin for " + target + "?\n\n"
                    + "This will also " + (isGrant ? "grant" : "revoke") + " their Admin role on the AML platform — the two are kept in sync.\n\n"
                    + "Admins can manage subscription & billing, payment details, company info, and other users in your firm.";
                if (! window.confirm(msg)) return;
                this.update_item_attachment(row, 'company_admin', value);
            },
            update_item_attachment: function (row, field, value, item) {
                // Quick update (AJAX POST to server) on related row, update single field or attached data, normally for FLAG field
                let current_object = this;
                if (typeof item === 'undefined') {
                    item = current_object.list_name;
                }

                if (typeof row[field] === 'undefined') {
                    row[field] = '';
                    current_object.$forceUpdate();
                }

                let post_data = {
                    render_type:'json',
                    form_id:'list_update_'+item,
                    skip_order_record: true,
                    data_row:{},
                };
                if (current_object.$root.current_id.user) {
                    post_data.user_id = current_object.$root.current_id.user;          // Applicant user_id, generally used for Admin Panel
                }

                let data_attachment_row = {reference_type:item,reference_id:row.id,content:{}};
                data_attachment_row.content[field] = value;
                post_data.data_row['data_attachment'] = [data_attachment_row];

                axios.post('/'+current_object.$root.panel+'/update_item', post_data)
                    .then(function (response) {
                        if (response.data) {
                            if (response.data.status) {
                                switch (response.data.status) {
                                    case 'OK':
                                        current_object.message_option.message_type = 'success';
                                        current_object.$root.set_item_list(response.data.item_list);
                                        current_object.$forceUpdate();
                                        break;
                                    case 'PERMISSION_DENIED':
                                        current_object.message_option.message_type = 'warning';
                                        break;
                                    default:
                                        current_object.message_option.message_type = 'error';
                                }
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                    if (current_object.message_option.message_type === 'success') {
                                        // hide message on successful login - required by MM
                                        current_object.message_option.message = '';
                                    }
                                }

                            } else {
                                current_object.message_option.message_type = 'error';
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                } else {
                                    current_object.message_option.message = 'System error, unable to login';
                                }
                            }
                        }

                    })
                    .catch(function (error) {
                        console.log('update_item_attachment error',error);
                    });

            },
            restore_item: function (row) {
                let current_object = this;
                let post_value = {
                    item: current_object.list_name,
                    id: row.id
                };
                axios.post('/'+current_object.$root.panel+'/restore_item', post_value)
                    .then(function (response) {
                        if (response.data) {
                            if (response.data.status) {
                                switch (response.data.status) {
                                    case 'OK':
                                        current_object.message_option.message_type = 'success';
                                        current_object.$root.set_item_list(response.data.item_list);
                                        // if (response.data.item_list) {
                                        //     Object.keys(response.data.item_list).forEach(function (module_name) {
                                        //         let result = current_object.$root.set_module_map(response.data.item_list[module_name], module_name);
                                        //         if (module_name === 'data_attachment') {
                                        //             current_object.$root.set_data_attachment(response.data.item_list.data_attachment);
                                        //         }
                                        //         current_object.$root.set_module_relationship(result,module_name);
                                        //     });
                                        //     // if (response.data.item_list.data_attachment) {
                                        //     //     current_object.$root.set_data_attachment(response.data.item_list.data_attachment);
                                        //     // }
                                        // }
                                        break;
                                    case 'PERMISSION_DENIED':
                                        current_object.message_option.message_type = 'warning';
                                        break;
                                    default:
                                        current_object.message_option.message_type = 'error';
                                }
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                    if (current_object.message_option.message_type === 'success') {
                                        // hide message on successful login - required by MM
                                        current_object.message_option.message = '';
                                    }
                                }

                            } else {
                                current_object.message_option.message_type = 'error';
                                if (response.data.message) {
                                    current_object.message_option.message = response.data.message;
                                } else {
                                    current_object.message_option.message = 'System error, unable to restore';
                                }
                            }
                        }

                    })
                    .catch(function (error) {
                        console.log('restore_item error',error);
                    });
            },
            view_item: function (row) {
                // Change page, normally to related form page, DOES NOT update server database in this function
                let current_object = this;

                switch (current_object.list_name) {
                    case 'bgl_company':
                        current_object.$root.set_page('/'+current_object.$root.panel+'/view-company',{id:row.id});
                        break;
                    default:
                        current_object.$root.set_page('/'+current_object.$root.panel+'/view-'+current_object.list_name.replace('_','-'),{id:row.id});
                        break;
                }
            },
            fieldsStyle: function () {
                let current_page = this.$root.item_map.page[this.$root.current_id.page];
                let list_field_style = {};
                if (current_page && current_page.list_field_style) {
                    list_field_style = current_page.list_field_style;
                }
                if (!list_field_style.sm) {
                    list_field_style.sm = {};
                }
                let style_text = '';
                this.list_controllers['top_controller'].forEach(function (list_controller) {
                    style_text += '\n' + '.list_wrapper .list_controller_container .list_controller_'+list_controller.name + ':after {content: "' + list_controller.label + '";}';
                });
                style_text += '\n' + '@media only screen and (max-width: 991px) {';
                if (list_field_style.sm) {
                    Object.keys(list_field_style.sm).forEach(function (field_name) {
                        style_text += '\n' + '.list_wrapper .list_container .list_column_' + field_name + ' ' + list_field_style.sm[field_name];
                    });
                }

                this.list_controllers['row_controller'].forEach(function (list_controller) {
                    style_text += '\n' + '.list_wrapper .list_controller_container .list_controller_'+list_controller.name + ':after {content: "' + list_controller.label + '";}';
                });
                this.fields.forEach(function (field) {
                    style_text += '\n' + '.list_wrapper .list_container .list_column_'+field.name + ':before {content: "' + field.display_name + ': ";}';
                });
                style_text += '\n' + '}';
                if (list_field_style.lg) {
                    style_text += '\n' + '@media only screen and (min-width: 992px) {';
                    Object.keys(list_field_style.lg).forEach(function (field_name) {
                        style_text += '\n' + '.list_wrapper .list_container .list_column_' + field_name + ' ' + list_field_style.lg[field_name];
                    });
                    style_text += '\n' + '}';
                }
                return style_text;
            },
            toggle_download_list: function (row) {
                let current_object = this;
                if (!row || row.id === current_object.current_download_list) {
                    current_object.current_download_list = -1;
                } else {
                    current_object.current_download_list = row.id
                }
            },
            set_list_order: function (field, order_seq) {
                let current_object = this;
                if (typeof field === 'string') {
                    let field_name = field;
                    field = null;
                    current_object.fields.forEach(function (field_item) {
                        if (field_name === field_item.name) {
                            field = field_item;
                        }
                    });
                }
                if (order_seq) {
                    current_object.order_seq = order_seq;
                } else {
                    if (field) {
                        if (current_object.order_by === field.name) {
                            if (current_object.order_seq === 'desc') {
                                current_object.order_seq = 'asc';
                            } else {
                                current_object.order_seq = 'desc';
                            }
                        } else {
                            if (field.order_seq_default) {
                                current_object.order_seq = field.order_seq_default;
                            } else {
                                current_object.order_seq = 'asc';
                            }
                        }
                    }
                }
                if (field) {
                    current_object.order_by = field.name;
                }
                // if (current_object.order_by === current_object.order_by_default) {
                //     delete current_object.uri_query['order_by'];
                // } else {
                //     current_object.uri_query['order_by'] = current_object.order_by;
                // }
                // if (current_object.order_seq === field.order_seq_default) {
                //     delete current_object.uri_query['order_seq'];
                // } else {
                //     current_object.uri_query['order_seq'] = current_object.order_seq;
                // }

                current_object.uri_query['order_by'] = current_object.order_by;
                current_object.uri_query['order_seq'] = current_object.order_seq;

                current_object.$root.set_page('',current_object.uri_query,{'update_state':'replaceState',scroll_top:true});
            },

        }
    }
</script>